import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

/** Lets the organization's agent settings admins open the agent trace on a chat turn. */
export const AgentTraceSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHandler = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label icon={MagnifyingGlassIcon} id="agent-trace-label" htmlFor="agent-trace">
        Agent trace for org admins
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="agent-trace"
          aria-labelledby="agent-trace-label"
          isSelected={organization.is_agent_trace_enabled}
          isDisabled={!organization.is_grove_enabled}
          isPending={isLoading}
          onChange={async () => {
            updateOrgHandler(
              updateOrganization({
                organization_id: orgId,
                updatePayload: { is_agent_trace_enabled: !organization.is_agent_trace_enabled },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
